export const PLAN_INTERVAL_TOGGLE_CLICKED = 'plan_interval_toggle_clicked';
export const SIGNUP_PAGE_LOADED = 'signup_page_loaded';
export const SIGNUP_SUBMIT_BUTTON_CLICKED = 'signup_submit_button_clicked';
export const LEAD_CREATED = 'Lead Created';
export const GOOGLE_SIGNUP_BUTTON_CLICKED = 'Google Signup Button Clicked';
export const AI_LEAD_GEN_ERROR_PARAM = 'ai_lead_gen_error';
export const AI_LEAD_GEN_ERROR_MSG = 'Oops! AI content unavailable, cannot generate preview.';
